import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import style from './_HomeBannerBox.scss';
import {HomeBannerBox} from 'components/home-banners';
import {HomeBanners} from 'base/api';
import { ShowIf, NoContent } from 'components/utils';

class HomeBannerList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadHomeBannersFromServer = this.loadHomeBannersFromServer.bind(this);
    this.postLoadHomeBanners = this.postLoadHomeBanners.bind(this);

    this.state = {
      items: {},
      listHomeBanners: [],
      isLoading: false
    }
  }

  componentDidMount() {
    this.loadHomeBannersFromServer();
  }

  loadHomeBannersFromServer() {
    this.setState({isLoading: true}, () => {
      HomeBanners.actions.list.request().then(response => {
        this.postLoadHomeBanners(response.data);
      });
    })
  }

  postLoadHomeBanners(homeBanners) {
    this.props.dispatch({
      type: 'UPDATE_HOME_BANNERS_LIST',
      homeBanners: homeBanners
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listHomeBanners != this.state.listHomeBanners) {
      this.setState({isLoading: true}, () => {
        this.setState({
          listHomeBanners: nextProps.listHomeBanners
        }, () => {
          this.setState({isLoading: false});
        });
      });
    }
  }

  render() {
    const {isLoading, listHomeBanners} = this.state;
    return (
      <div className='container-fluid'>
        <div className="container-fluid">
          <section className="list-home-banner">
            <ShowIf condition={isLoading || (listHomeBanners && listHomeBanners.length === 0)}>
              <div className="row">
                <NoContent
                  content={isLoading ? 'Đang tải dữ liệu...' : 'Không có kết quả nào'}
                  height={300}
                />
              </div>
            </ShowIf>
            <ShowIf condition={!isLoading && listHomeBanners && listHomeBanners.length > 0}>
              <div className="row">
                {listHomeBanners.map((banner, index) => (
                  <HomeBannerBox key={index} data={banner}/>
                ))}
              </div>
            </ShowIf>
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    listHomeBanners: state.listHomeBanners
  };
}

export default connect(mapStateToProps)(HomeBannerList);



// WEBPACK FOOTER //
// ./components/home-banners/HomeBannerList.jsx